import "./__thumbnail.scss"

